import BotssyWidget from './BotssyWidget';
import PortalIcon from './PortalIcon';

const topics = [
  ['box', 'Pedidos', 'Recepción, procesamiento y rótulos.'],
  ['truck', 'Colectas', 'Cómo crear, editar y abonar un retiro.'],
  ['card', 'Pagos', 'Mercado Pago, importes y comprobantes.'],
  ['help', 'Cuenta', 'Datos de perfil y seguridad.'],
];

export default function PortalSoporte() {
  return (
    <div className="portal-app">
      <div className="portal-wrap">
        <header className="portal-page-header"><p className="portal-kicker">Centro de ayuda</p><h1>Soporte</h1><p>Encontrá respuestas rápidas o hablá con nuestro asistente para resolver cualquier duda de tu operación.</p></header>
        <div className="portal-support-grid">
          <section className="portal-card portal-support-card">
            <p className="portal-kicker">Temas frecuentes</p>
            <h2>¿En qué podemos ayudarte?</h2>
            <p>Elegí un tema para orientar tu consulta. Si necesitás atención personalizada, abrí el chat de Botssy.</p>
            <div className="portal-support-topics">{topics.map(([icon, title, description]) => <div className="portal-support-topic" key={title}><PortalIcon name={icon} size={20} /><div><strong>{title}</strong><span className="portal-muted">{description}</span></div></div>)}</div>
          </section>
          <section className="portal-card portal-support-card portal-chat-card">
            <div><div className="portal-chat-mark"><PortalIcon name="chat" size={26} /></div><p className="portal-kicker">Asistente ESA</p><h2>Chat con Botssy</h2><p>Consultá sobre tus pedidos, colectas, pagos y el uso del portal. El botón de chat queda disponible en toda la pantalla.</p></div>
            <p className="portal-muted" style={{ color: 'rgba(255,255,255,.5)' }}>Chat online · Respuesta inmediata</p>
          </section>
        </div>
      </div>
      <BotssyWidget />
    </div>
  );
}
